export class ArquivoOptions {
    canOpen: boolean;
    canDownload: boolean;
    canDelete: boolean;

    /** Verifica se possui alguma opção habilitada */
    hasAnyOption(): boolean {
        return this.canOpen ||
            this.canDownload ||
            this.canDelete;
    }
}
